// VueMatomo地址
export const NUXT_MATOMO_URL = import.meta.env.VITE_NUXT_MATOMO_URL;

// 接口 baseUrl
export const NUXT_API_URL = import.meta.env.VITE_NUXT_API_URL;

// 网站运行地址
export const NUXT_BASE_URL = import.meta.env.VITE_NUXT_BASE_URL;

// google登录地址
export const NUXT_FAC_SOCIAL_LOGIN_URL = import.meta.env
  .VITE_NUXT_FAC_SOCIAL_LOGIN_URL;

// 内测标识
export const NUXT_TEXTING =
  import.meta.env.VITE_NUXT_TEXTING?.toLowerCase() === "true" || false;

// Sentry地址
export const NUXT_SENTRY_URL = import.meta.env.VITE_NUXT_SENTRY_URL;

// 是否开启Sentry
export const NUXT_SENRTY =
  import.meta.env.VITE_NUXT_SENTRY?.toLowerCase() === "true" || false;
